import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import { certificateCourseData } from '../CertificateCourse.Data';
import { handleConditionBaseFields } from '../utils/ValidationBaseFields';
import FormCreator from '../../../../../../components/Forms/FormCreator';

const CertificateCourseForm = forwardRef((props, ref) => {
    const certificateCourseRef = useRef();
    const [formData, setFormData] = useState(certificateCourseData);

    const resetForm = () => {
        const pathwayValue = props?.initData?.gmaPathwayTypeID;
        let form = pathwayValue ? handleConditionBaseFields(pathwayValue, "gmaPathwayTypeID") : { ...certificateCourseData };
        form.initialState = { ...props.initData };
        setFormData(form);
    }

    useImperativeHandle(ref, () => ({
        getFormData: () => {
            const certificateData = certificateCourseRef.current.getFormData();
            if (ref?.current && certificateData) {
                resetForm();
                return certificateData;
            }
            return null;
        }
    }))

    useEffect(() => {
        resetForm();
        if (props.isEdit && props.initData) {
        }
    }, [props.isEdit, props.initData]);

    const handleClear = () => {
        const updatedForm = { ...formData };
        updatedForm.initialState.certificateAttachment = null;
        // certificateCourseData.formFields.find(item => item.id === "certificateAttachment").fieldSetting.isDownloadable = false;
        setFormData(updatedForm);
    }

    const handleDownload = (data, dataField) => {
        if (props.onDownload) {
            props.onDownload(data, dataField);
        }
    }

    const handleDropdownChange = (data, dataField) => {
        if (dataField === "gmaPathwayTypeID") {
            const updateForm = handleConditionBaseFields(data.value, dataField)
            setFormData(updateForm);
        }
    }

    const formActionHandler = {
        CLEAR: handleClear,
        DOWNLOAD: handleDownload,
        DDL_CHANGED: handleDropdownChange
    }

    const handleFormFieldChange = (dataField, value) => {
        if (props.onFormFieldValueChange) {
            props.onFormFieldValueChange(dataField, value)
        }
        if (dataField === "gmaPathwayTypeID") {
            setFormData((previousData) => ({
                ...previousData,
                initialState: {
                    ...previousData.initialState,
                    gmaPathwayTypeID: value?.value,
                    gmapCertificateTypeP2Id: "",
                    IHLCertificateTypeId: "",
                },
            }));
            return;
        }
        if (dataField === "IHLCertificateTypeId") {
            setFormData((previousData) => ({
                ...previousData,
                initialState: {
                    ...previousData.initialState,
                    IHLCertificateTypeId: value?.value,
                    gmapCertificateTypeP2Id: value?.value ? 7 : "",
                },
            }));
        }
    }
    return (
        <FormCreator ref={certificateCourseRef} {...formData} onActionChange={formActionHandler} onFormFieldValueChange={handleFormFieldChange} handleTableEdit={props.handleTableEdit} handleTableDelete={props.handleTableDelete} />
    )
})

export default CertificateCourseForm